<template>
	<Loading :loading="loading" class="row">
		<ListingHeader :title="'Shop'" :savings="categorySavings" />
		<CategorySidebar class="offset-md-1"/>


		<div class="col-12 col-md-8" v-if="categories" id="subcategoryList">
			<div class="row">
				<div class="col-12 order-md-last">
					<div class="row">
						<div class="col-12">
							<div class="row">
								<h2 class="col-12">Categories</h2>
								<CategoryItem v-for="(category, index) in mappedCategories" :key="index" :item="category"/>
							</div>
						</div>
					</div>
				</div>		
			</div>
		</div>
		<vue-headful
		:title="'Shop ' + (currentCategory && currentCategory.category ? currentCategory.category + ' | Cherrytree' : 'Cherrytree')"
		:description="currentCategory.category"
		/>
	</Loading>
</template>

<script>
import CategoryItem from "./CategoryItem";
import CategorySidebar from "./CategorySidebar";
// import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
import ListingHeader from "@/sections/shop/listing/ListingHeader";
import { mapState } from "vuex";
import Loading from "@/components/loading/Loading";

export default {
	name: "ShopListing",
	components: {
		CategoryItem,
		CategorySidebar,
		// Breadcrumbs
		ListingHeader,
		Loading
	},
	data() {
		return {
			specials: null,
			savings: null,
		};
	},
	computed: {
		...mapState({
			// map categories to store.reference.categories
			categories: state => state.reference.categories
		}),
		loading() {
			return this.categories == null;
		},
		currentCategory() {
			let catId = this.$route.params.category;
			if (!catId || !this.categories) return "";
			return this.categories[catId];
		},
		subcategories() {
			let catId = this.$route.params.category;
			if (!catId || !this.categories) return [];
			let subcats = this.categories[catId].children;

			let sorted = Object.values(subcats).sort((a,b) => {
				return a.category.localeCompare(b.category)
			})

			return sorted;
		},
		categorySavings() {
			let savingsString = "";
			if (this.savings != null && this.savings.max_saving != null && this.savings.min_saving != null) {
				savingsString = "Gold Members save between " + this.savings.min_saving + " and " + this.savings.max_saving + "%";
			}
			return savingsString
		},
		mappedCategories(){
			if (!this.categories) return []

			// 1635 = View All Discounts (discount partners)
			// 1458 = Cherrytree
			let hiddenItems = ["1635", "1458"];

			//2 = entertainment
			//4 = auto
			//11= jewellery
			//1880 = showroom Stock
			//1621 = crafts
			//1926 = gift ideas
			// let moreItems = ["2", "4", "11", "1621", "1926"];

			let cats =  Object.values(this.categories).map(category =>{

				if (hiddenItems.includes(category.id)){
					return null;
				}

				// let inMore = false;
				// if(moreItems.includes(category.id)){
				// 	inMore = true;
				// }

				let name = category.category

				let children = null;
				if (category.children){
					children = Object.values(category.children).sort((a,b) => a.category.localeCompare(b.category))
				}
				return {category: name, id: category.id, children: children, images: category.images}//, inMore:inMore, images: category.images}

			})
			cats.push({category: "Specials"})
			return cats.filter(item => item != null).sort((a,b) => a.category.localeCompare(b.category))
		},
		mainItems(){
			return this.mappedCategories.filter(item => !item.inMore)
		},
	}
};
</script>

<style lang="scss">
// sidebar styles are set in the sidebar.scss file in styles folder, changes will affect all sidebars
	@include media-breakpoint-down(md){
		.productSpecials{
			padding: 30px 15px;
		}
		.promoTile{
			padding: 40px 0 20px;
		}
	}
	.savings {
		font-size: 1.5rem;
	}
</style>
